// import utils
import { makeObservable, observable, action, runInAction } from "mobx";
class AnnouncekitStore {
    ref = null;
    unreads = 0;
    loading = true;
    constructor() {
        makeObservable(this, {
            ref: observable,
            unreads: observable,
            loading: observable,
            updateUnreads: action,
            setRef: action,
            open: action,
            close: action,
            unread: action,
            instance: action,
            withWidget: action,
        });
    }
    open = () => this.ref?.open();
    close = () => this.ref?.close();
    unread = () => this.ref?.unread();
    instance = () => this.ref?.instance();
    withWidget = () => this.ref?.withWidget();
    updateUnreads = () => {
        this.loading = true;
        this.ref
            ?.unread()
            .then((unreads) => {
            if (typeof unreads !== "number")
                return;
            runInAction(() => {
                this.unreads = unreads;
            });
        })
            .catch(console.error)
            .finally(() => {
            runInAction(() => {
                this.loading = false;
            });
        });
    };
    setRef(ref) {
        this.loading = true;
        this.ref = ref;
        ref
            .unread()
            .then((unreads) => {
            if (typeof unreads !== "number")
                return;
            runInAction(() => {
                this.unreads = unreads;
            });
        })
            .catch(console.error)
            .finally(() => {
            runInAction(() => {
                this.loading = false;
            });
        });
    }
}
export const announcekitStore = new AnnouncekitStore();
export default announcekitStore;
